var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldable',{attrs:{"name":_vm.name,"label":_vm.label,"required":_vm.required,"errors":_vm.errors,"no":_vm.independent}},[_c('el-autocomplete',{staticClass:"w-full",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"fetch-suggestions":_vm.querySearchAsync,"value-key":"name"},on:{"input":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }